import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=8f8487e4&scoped=true&"
import script from "./classify.vue?vue&type=script&lang=js&"
export * from "./classify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8487e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f8487e4')) {
      api.createRecord('8f8487e4', component.options)
    } else {
      api.reload('8f8487e4', component.options)
    }
    module.hot.accept("./classify.vue?vue&type=template&id=8f8487e4&scoped=true&", function () {
      api.rerender('8f8487e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/popularize/classify.vue"
export default component.exports